module.exports = __webpack_public_path__ + "img/person2.aec75f8b.png";